(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSAsignacionDetailController', SSAsignacionDetailController);

    SSAsignacionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SSAsignacion', 'SSPeriodo', 'SSUnidadReceptora', 'SSPersona', 'AlumnoUadyMatriculado', 'SSPerfil'];

    function SSAsignacionDetailController($scope, $rootScope, $stateParams, previousState, entity, SSAsignacion, SSPeriodo, SSUnidadReceptora, SSPersona, AlumnoUadyMatriculado, SSPerfil) {
        var vm = this;

        vm.sSAsignacion = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:sSAsignacionUpdate', function(event, result) {
            vm.sSAsignacion = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
